import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import EtiquetasScreen from "../components/evento/EtiquetasScreen"

const EtiquetasPage = ({ data, location }) => {
  const { state = {} } = location

  let etiqueta = ""
  if (state) {
    if (state.etiqueta) {
      etiqueta = state.etiqueta
    }
  }

  const etiquetas = data.allStrapiAgendaMasterEtiqueta.edges.map(
    edge => edge.node
  )

  const eventos = data.allApiExternaEventosNext.edges.map(edge => edge.node)

  const resultData = {
    next: eventos,
    etiquetas: etiquetas,
    variablesEntorno: {
      AGENDA_APP_SITE: data.site.siteMetadata.AGENDA_APP_SITE,
    },
  }

  return (
    <Layout>
      <SEO title="Etiquetas" pathname="/etiquetas" />
      <EtiquetasScreen resultData={resultData} etiqueta={etiqueta} />
    </Layout>
  )
}
export default EtiquetasPage

export const pageQuery = graphql`
  query EtiquetasQuery {
    allStrapiAgendaMasterEtiqueta {
      edges {
        node {
          Nombre
          id
          strapiId
        }
      }
    }
    site {
      siteMetadata {
        title
        AGENDA_APP_SITE
      }
    }
    allApiExternaEventosNext(filter: { id: { ne: "dummy" } }) {
      edges {
        node {
          slug
          EventoDestacado
          ImagenDestacada {
            alternativeText
            alternative_id
            ext
            name
            mime
            height
            provider
            size
            url
            width
          }
          Titulo
          Fechas {
            Fecha
            Fin
            Inicio
            _xcomponent
            alternative_id
          }
          WorkFlow
          alternative_id
          area_tematicas {
            Nombre
            alternative_id
          }
          tipo_evento {
            Nombre
            TipoEvento
            alternative_id
          }
          id
          Lugar {
            DescripcionLink
            DescripcionLugar
            URL
            Ubicacion
            agenda_master_lugar_pucp {
              Nombre
              alternative_id
            }
            alternative_id
            _xcomponent
          }
          agenda_master_etiquetas {
            Nombre
            alternative_id
          }
        }
      }
    }
  }
`
